import { render, staticRenderFns } from "./order.vue?vue&type=template&id=ac0d9f30&scoped=true&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"
import style0 from "./order.css?vue&type=style&index=0&id=ac0d9f30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0d9f30",
  null
  
)

export default component.exports